import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderCargoTaxiDraft from "./billings-order-cargo-taxi-draft";
import BillingsOrderCargoTaxiDraftParams from "./billings-order-cargo-taxi-draft-params";

const useBillingsOrderCargoTaxiDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderCargoTaxiDraft | null>(null);

  const load = async (
    params: BillingsOrderCargoTaxiDraftParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderCargoTaxiBillingsDraft(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderCargoTaxiDraft;
